export default "__VITE_ASSET__CtNrEj1y__"